import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export const PrivacyPage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-388">
      <SEO title="Privacyverklaring - Blue Rain Productions" description="Lees hoe Blue Rain Productions omgaat met uw persoonlijke gegevens. Onze privacyverklaring beschrijft welke informatie we verzamelen en waarom." data-id="element-389" />
      <Navbar data-id="element-390" />
      <main data-id="element-391">
        <section className="py-32 bg-gradient-to-b from-black to-gray-950 w-full" data-id="element-392">
          <div className="container mx-auto px-4 md:px-6" data-id="element-393">
            <h1 className="text-4xl md:text-6xl font-bold mb-8 text-center" data-id="element-394">
              Privacyverklaring
            </h1>
            <div className="max-w-4xl mx-auto mt-12 mb-16" data-id="element-395">
              <div className="prose prose-invert prose-lg" data-id="element-396">
                <p className="text-gray-300 mb-6" data-id="element-397">
                  Bij Blue Rain Productions hechten wij grote waarde aan de
                  privacy van onze websitebezoekers en klanten. Deze
                  privacyverklaring beschrijft hoe wij omgaan met persoonlijke
                  gegevens die wij verzamelen wanneer u onze website bezoekt of
                  gebruik maakt van onze diensten.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-398">
                  Welke gegevens verzamelen wij?
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-399">
                  Wij kunnen de volgende persoonlijke gegevens verzamelen:
                </p>
                <ul className="list-disc pl-6 text-gray-300 space-y-2 mb-6" data-id="element-400">
                  <li data-id="element-401">
                    Naam en contactgegevens (zoals e-mailadres en
                    telefoonnummer)
                  </li>
                  <li data-id="element-402">Informatie die u verstrekt via contactformulieren</li>
                  <li data-id="element-403">Gegevens over uw bezoek aan onze website via cookies</li>
                  <li data-id="element-404">Informatie die u verstrekt in correspondentie met ons</li>
                </ul>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-405">
                  Waarom verzamelen wij deze gegevens?
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-406">
                  Wij verzamelen en verwerken uw persoonlijke gegevens voor de
                  volgende doeleinden:
                </p>
                <ul className="list-disc pl-6 text-gray-300 space-y-2 mb-6" data-id="element-407">
                  <li data-id="element-408">Om onze diensten aan u te kunnen leveren</li>
                  <li data-id="element-409">Om met u te communiceren over onze diensten</li>
                  <li data-id="element-410">Om onze website en diensten te verbeteren</li>
                  <li data-id="element-411">Om te voldoen aan wettelijke verplichtingen</li>
                </ul>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-412">
                  Bewaartermijn
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-413">
                  Wij bewaren uw persoonlijke gegevens niet langer dan
                  noodzakelijk is voor de doeleinden waarvoor deze zijn
                  verzameld, tenzij wij wettelijk verplicht zijn gegevens langer
                  te bewaren.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-414">
                  Uw rechten
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-415">U heeft het recht om:</p>
                <ul className="list-disc pl-6 text-gray-300 space-y-2 mb-6" data-id="element-416">
                  <li data-id="element-417">
                    Inzage te vragen in de persoonlijke gegevens die wij over u
                    hebben
                  </li>
                  <li data-id="element-418">
                    Correctie te vragen van onjuiste persoonlijke gegevens
                  </li>
                  <li data-id="element-419">Verwijdering van uw persoonlijke gegevens te vragen</li>
                  <li data-id="element-420">
                    Bezwaar te maken tegen bepaalde verwerkingen van uw
                    persoonlijke gegevens
                  </li>
                </ul>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-421">
                  Wijzigingen in deze privacyverklaring
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-422">
                  Wij kunnen deze privacyverklaring van tijd tot tijd aanpassen.
                  Wijzigingen zullen op deze pagina worden gepubliceerd. We
                  raden u aan om deze privacyverklaring regelmatig te raadplegen
                  om op de hoogte te blijven van eventuele wijzigingen.
                </p>
                <h2 className="text-2xl font-semibold mt-10 mb-4 text-white" data-id="element-423">
                  Contact
                </h2>
                <p className="text-gray-300 mb-6" data-id="element-424">
                  Als u vragen heeft over deze privacyverklaring of over hoe wij
                  omgaan met uw persoonlijke gegevens, neem dan contact met ons
                  op via:
                </p>
                <p className="text-gray-300 mb-6" data-id="element-425">
                  E-mail: info@bluerainproductions.nl
                  <br data-id="element-426" />
                  Telefoon: +31651764541
                </p>
                <p className="text-gray-400 mt-10 text-sm" data-id="element-427">
                  Laatste update:{' '}
                  {new Date().toLocaleDateString('nl-NL', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-428" />
    </div>;
};